import api from "@/lib/api";

// Fase 5.2.5 — Helper PWA / Web Push (VAPID)

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (e) {
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

// Chiede permesso, si iscrive e registra la subscription sul backend.
export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifiche non supportate su questo dispositivo");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");

  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerServiceWorker());
  await navigator.serviceWorker.ready;

  const { data } = await api.get("/push/vapid-public-key");
  const existing = await reg.pushManager.getSubscription();
  const sub =
    existing ||
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    }));

  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function disablePush() {
  const sub = await getSubscription();
  const endpoint = sub?.endpoint;
  if (sub) { try { await sub.unsubscribe(); } catch (e) { console.debug("push unsubscribe failed", e); } }
  await api.post("/push/unsubscribe", { endpoint });
  return true;
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
